var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('oie-my-pages-template',{attrs:{"title":_vm.title,"text":_vm.t('myUsersEditUserSubTitle2'),"with-go-back":true}},[_c('oie-add-edit-user-form',{on:{"cancel":function($event){return _vm.goToSubPage(_vm.navigationOptions.oieMyUsers)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }